module.exports = __webpack_public_path__ + "media/images/home/concept_2_sp-19379340beab13dca7764dd34dbe3347.png";